import React from 'react';
import { Image } from '@cian/ui-kit/image';
import { Undergrounds } from '../Undergrounds';
import { Address } from '../Address';
import { IGeoForDesktopSchema } from '../../repositories/favorites/entities/favorite_entity_for_desktop/GeoForDesktopSchema';

interface IFavoriteItem {
  fullUrl: string;
  title: string;
  price?: string | null;
  photoFullUrl?: string | null;
  geo: IGeoForDesktopSchema;
  onClick(): void;
}

export const FavoriteItem: React.FC<IFavoriteItem> = ({ fullUrl, title, price, photoFullUrl, geo, onClick }) => {
  return (
    <a
      className="c-notification-center__link"
      href={fullUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <div className="c-notification-center__block c-notification-center__block--notification">
        <div className="c-notification-center__content">
          <p className="c-notification-center__title">{title}</p>
          {price && <p className="c-notification-center__description">{price}</p>}
          {geo &&
            (geo.undergrounds.length > 0 ? (
              <Undergrounds undergrounds={geo.undergrounds} />
            ) : (
              <Address address={geo.address} />
            ))}
        </div>
        <Image height={44} width={44} src={photoFullUrl || ''} />
      </div>
    </a>
  );
};
